import { cannectDefaultProduct } from 'assets/img'
import { usePrepareCart } from 'hooks/usePrepareCart'
import useMediaQuery from 'hooks/useMediaQuery'
import { noop } from 'lodash'
import { useState } from 'react'

import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import { FiShoppingCart } from 'react-icons/fi'
import { useHistory } from 'react-router'
import { temporaryTheme } from 'styles/theme'
import { MOBILE_WIDTH, TABLET_WIDTH } from 'utils/constants'
import { formatPrice } from 'utils/formatters'
import When from 'utils/when'
import * as Styles from './styles'

export interface CardItemTypes {
  isFavorite: boolean
  image: any[]
  name: string
  shippingType: number
  product_id: string | number
  product?: any
  removeFavorite: any
  price: number
}

export function CardItem({
  image,
  isFavorite,
  name,
  product_id,
  shippingType,
  product,
  removeFavorite = noop,
  price
}: CardItemTypes) {
  const imagePath = image?.filter((item) => item?.format === 'IMG') || []
  const { addToCart } = usePrepareCart()
  const [isLoading, setIsLoading] = useState(false)
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  const isTablet = useMediaQuery(TABLET_WIDTH)
  const history = useHistory()

  const ShippingText =
    product.stock <= 0 ? 'possível maior tempo de entrega' : 'importado - entrega em até 15 dias úteis'
  const ButtonText = shippingType === 18 || shippingType === 27 ? 'Comprar' : 'Importar'

  const getProductDetails = () => {
    history.push(`/detalhes-produtos/${product_id}`)
  }

  const handleAddToCart = async () => {
    // Verificar se o produto tem todos os campos necessários
    if (!product || !product.id || isLoading) {
      return
    }

    setIsLoading(true)
    try {
      await addToCart(product.id, 1, product.class_id, product.brand_id, product?.type)
    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Styles.Wrapper>
      <Styles.Content>
        <Styles.FavoriteBox onClick={() => removeFavorite(product_id, product)}>
          {isFavorite ? <AiFillHeart color={temporaryTheme.colors.red} /> : <AiOutlineHeart color="#858585" />}
        </Styles.FavoriteBox>
        <Styles.ImageBox>
          <Styles.Image src={imagePath[0]?.path || cannectDefaultProduct} alt="Imagem do produto" />
        </Styles.ImageBox>
        <Styles.DetailsBox>
          <Styles.Description onClick={getProductDetails}>{name}</Styles.Description>
          <Styles.PriceBox>
            <Styles.Price>
              {formatPrice({ value: price, currencyDisplay: 'symbol', currencyStyle: 'BRL', type: 'pr-br' })}
            </Styles.Price>
            <When expr={!isMobile && !isTablet}>
              <Styles.ShippingMessage>{ShippingText}</Styles.ShippingMessage>
            </When>
          </Styles.PriceBox>
        </Styles.DetailsBox>
      </Styles.Content>

      <Styles.ActionsWrapper>
        <Styles.ActionBox>
          <Styles.ButtonProduct onClick={handleAddToCart} disabled={isLoading}>
            {isLoading ? 'Carregando...' : ButtonText} <FiShoppingCart />
          </Styles.ButtonProduct>
        </Styles.ActionBox>

        <When expr={isMobile || isTablet}>
          <Styles.ShippingMessage>{ShippingText}</Styles.ShippingMessage>
        </When>
      </Styles.ActionsWrapper>
    </Styles.Wrapper>
  )
}
